import { Box, Divider, Stack } from '@mui/material';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';

import { BonusSettlementTab } from '../../models/bonus-settlement-tab';
import { bonusSettlementsSupplierOverviewDetailsSelector } from '../store/bonus-settlements-supplier-overview-selector';
import { useAppSelector } from '../../../../../store/use-appstate-selector';

interface BonusSettlementSupplierOverviewDetailSidebarProps {
    selectedTab: BonusSettlementTab;
}

export const BonusSettlementSupplierOverviewDetailSidebar = (
    props: BonusSettlementSupplierOverviewDetailSidebarProps
): ReactElement => {
    const { selectedTab } = props;
    const details = useAppSelector(bonusSettlementsSupplierOverviewDetailsSelector);
    const currency = useAppSelector(state => state.settings.currency);
    const total =
        details !== undefined
            ? (details.totalBonusByClassification.BONUS ?? 0) +
              (details.totalBonusByClassification.BONUS_PLUS ?? 0) +
              (details.totalBonusByClassification.CONTRACT ?? 0)
            : 0;

    return (
        <>
            {selectedTab === BonusSettlementTab.Supplier && (
                <Stack sx={{ p: 4 }} typography="body2" gap={3}>
                    <Box>
                        <PoolTypography typography="subtitle1" translationId="app.common.overallOverview" />
                    </Box>
                    <Stack gap={1}>
                        <Stack direction="row" justifyContent="space-between">
                            <Box>
                                <FormattedMessage id="app.bonusSettlementsSupplierOverview.detail.bonusClassification.bonus" />
                            </Box>
                            <Box>
                                <FormattedNumber
                                    maximumFractionDigits={2}
                                    style="currency"
                                    currency={currency}
                                    value={details?.totalBonusByClassification.BONUS ?? 0}
                                />
                            </Box>
                        </Stack>
                        <Divider />
                        <Stack direction="row" justifyContent="space-between">
                            <Box>
                                <FormattedMessage id="app.bonusSettlementsSupplierOverview.detail.bonusClassification.bonusPlus" />
                            </Box>
                            <Box>
                                <FormattedNumber
                                    maximumFractionDigits={2}
                                    style="currency"
                                    currency={currency}
                                    value={details?.totalBonusByClassification.BONUS_PLUS ?? 0}
                                />
                            </Box>
                        </Stack>
                        <Divider />
                        <Stack direction="row" justifyContent="space-between">
                            <Box>
                                <FormattedMessage id="app.bonusSettlementsSupplierOverview.detail.bonusClassification.contract" />
                            </Box>
                            <Box>
                                <FormattedNumber
                                    maximumFractionDigits={2}
                                    style="currency"
                                    currency={currency}
                                    value={details?.totalBonusByClassification.CONTRACT ?? 0}
                                />
                            </Box>
                        </Stack>
                        <Divider />
                        <Stack direction="row" justifyContent="space-between">
                            <Box>
                                <FormattedMessage id="app.label.total" />
                            </Box>
                            <Box>
                                <FormattedNumber
                                    maximumFractionDigits={2}
                                    style="currency"
                                    currency={currency}
                                    value={total}
                                />
                            </Box>
                        </Stack>
                    </Stack>
                </Stack>
            )}
        </>
    );
};
